import { render, staticRenderFns } from "./SavedToPendingTRModal.vue?vue&type=template&id=413a867a"
import script from "./savedToPendingTRModal.ts?vue&type=script&lang=ts&external"
export * from "./savedToPendingTRModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports